
//首页信息
const index = {

    // 用户数据
    userData:[
        {
            name:'',
            count:'10',
            unit:'M+',
            type:['注册玩家','注册玩家','Number of players'],
            imgURL:'',
            bgColor:'#58bd95'
        },
        {
            name:'',
            count:'100',
            unit:'K+',
            type:['活跃玩家','活跃玩家','Active user'],
            imgURL:'',
            bgColor:'#3b3b63'
        },
        {
            name:'',
            count:'>60',
            unit:'%',
            type:['次日留存','次日留存','Next day retention'],
            imgURL:'',
            bgColor:'#5e94f1'
        },
        {
            name:'',
            count:'90',
            unit:'Days+',
            type:['平均留存日数','平均留存日數','Averaging days'],
            imgURL:'',
            bgColor:'#ddb65f'
        },
        {
            name:'',
            count:'140k',
            unit:'Hours+',
            type:['每日游戏时间','每日游戏时间','One day playtime'],
            imgURL:'',
            bgColor:'#ed6172'
        },
        {
            name:'',
            count:'5',
            unit:'M+',
            type:['广告日显示量','广告日显示量','One day advertising display'],
            imgURL:'',
            bgColor:'#5a599a'
        },
    ],
}
// 游戏信息配置
const games = {
    //遊戲鍵  => 鋤大D 大亨
    btthk:{
        gameKey:'btthk',
        name:['开心方块','开心方块','Happy Blocks'],
        subTitle:['令人上瘾的休闲方块益智游戏','令人上瘾的休闲方块益智游戏','令人上瘾的休闲方块益智游戏'],
        info:[
            '怎么玩？<br/> ⁃ 向左或向右滑动方塊。<br/> ⁃ 将方块填充成一条水平线以清除它们。<br/> ⁃ 没有时间限制！<br/> ⁃ 只需要滑动！<br/> <br/> 特征 ：<br/> ⁃ 轻松简单，没有压力，没有时间限制。<br/> ⁃ 挑战你的上层记录。<br/> ⁃ 容易上手。 老少皆宜的经典益智游戏和方块游戏！<br/> ⁃ 多张漂亮的背景图片。<br/> ⁃ 多种材料的积木。 如：珠宝、金属、水晶、木头......<br/> <br/> 快来玩这个游戏，成为方块益智游戏的高手吧！<br/> ' ,   
            '怎么玩？<br/> ⁃ 向左或向右滑动方塊。<br/> ⁃ 将方块填充成一条水平线以清除它们。<br/> ⁃ 没有时间限制！<br/> ⁃ 只需要滑动！<br/> <br/> 特征 ：<br/> ⁃ 轻松简单，没有压力，没有时间限制。<br/> ⁃ 挑战你的上层记录。<br/> ⁃ 容易上手。 老少皆宜的经典益智游戏和方块游戏！<br/> ⁃ 多张漂亮的背景图片。<br/> ⁃ 多种材料的积木。 如：珠宝、金属、水晶、木头......<br/> <br/> 快来玩这个游戏，成为方块益智游戏的高手吧！<br/> ' ,   
            '怎么玩？<br/> ⁃ 向左或向右滑动方塊。<br/> ⁃ 将方块填充成一条水平线以清除它们。<br/> ⁃ 没有时间限制！<br/> ⁃ 只需要滑动！<br/> <br/> 特征 ：<br/> ⁃ 轻松简单，没有压力，没有时间限制。<br/> ⁃ 挑战你的上层记录。<br/> ⁃ 容易上手。 老少皆宜的经典益智游戏和方块游戏！<br/> ⁃ 多张漂亮的背景图片。<br/> ⁃ 多种材料的积木。 如：珠宝、金属、水晶、木头......<br/> <br/> 快来玩这个游戏，成为方块益智游戏的高手吧！<br/> ' ,   
            ],
        appleURL:'#',
        googleURL:'#',
        downloads:'50000+',
        imgURL:'../../static/img/games/btthk_icon.png'
    },
    fmj16:{
        gameKey:'fmj16',
        name:['数字大师','数字大师','Number Master'],
        subTitle:['大量全新的挑战性数字谜题', '大量全新的挑战性数字谜题', '大量全新的挑战性数字谜题'],
        info:[
            '是一款令人上瘾放松的数字游戏。跳入新的数字匹配游戏，攻克大量全新的挑战性数字谜题并训练您的大脑！挑战您的思维并解决谜题，然后您会发现它们既简单又令人兴奋！<br/> <br/> 怎么玩？<br/> - 您需要找到并匹配相同数字对（6-6、7-7）或加起来为 10 的数字对（1-9、3-7）。只需依次点击两个数字，即可将它们从棋盘上消除。<br/> - 可配对的数字必须位置相邻。您可以将位于垂直、水平或对角线位置的数字消除，并且当一个数字位于该行的最后一个单元格中而另一个数字位于下一行的第一个单元格中时，您也可以将它们配对。<br/> - 2个可匹配数字之间也可以有空单元格。<br/> - 尝试清除棋盘上的数字以获得最高分。<br/> - 当没有更多号码可消除时，点击下面的数字来添加。<br/> <br/> 特征：<br/> - 十分简单，没有压力，没有时间限制。<br/> - 挑战打破你的最高分。<br/> - 易于上手。老少皆宜的经典益智游戏和数字游戏！<br/> - 超过1000个关卡！<br/> ' ,   
            '是一款令人上瘾放松的数字游戏。跳入新的数字匹配游戏，攻克大量全新的挑战性数字谜题并训练您的大脑！挑战您的思维并解决谜题，然后您会发现它们既简单又令人兴奋！<br/> <br/> 怎么玩？<br/> - 您需要找到并匹配相同数字对（6-6、7-7）或加起来为 10 的数字对（1-9、3-7）。只需依次点击两个数字，即可将它们从棋盘上消除。<br/> - 可配对的数字必须位置相邻。您可以将位于垂直、水平或对角线位置的数字消除，并且当一个数字位于该行的最后一个单元格中而另一个数字位于下一行的第一个单元格中时，您也可以将它们配对。<br/> - 2个可匹配数字之间也可以有空单元格。<br/> - 尝试清除棋盘上的数字以获得最高分。<br/> - 当没有更多号码可消除时，点击下面的数字来添加。<br/> <br/> 特征：<br/> - 十分简单，没有压力，没有时间限制。<br/> - 挑战打破你的最高分。<br/> - 易于上手。老少皆宜的经典益智游戏和数字游戏！<br/> - 超过1000个关卡！<br/> ' ,   
            '是一款令人上瘾放松的数字游戏。跳入新的数字匹配游戏，攻克大量全新的挑战性数字谜题并训练您的大脑！挑战您的思维并解决谜题，然后您会发现它们既简单又令人兴奋！<br/> <br/> 怎么玩？<br/> - 您需要找到并匹配相同数字对（6-6、7-7）或加起来为 10 的数字对（1-9、3-7）。只需依次点击两个数字，即可将它们从棋盘上消除。<br/> - 可配对的数字必须位置相邻。您可以将位于垂直、水平或对角线位置的数字消除，并且当一个数字位于该行的最后一个单元格中而另一个数字位于下一行的第一个单元格中时，您也可以将它们配对。<br/> - 2个可匹配数字之间也可以有空单元格。<br/> - 尝试清除棋盘上的数字以获得最高分。<br/> - 当没有更多号码可消除时，点击下面的数字来添加。<br/> <br/> 特征：<br/> - 十分简单，没有压力，没有时间限制。<br/> - 挑战打破你的最高分。<br/> - 易于上手。老少皆宜的经典益智游戏和数字游戏！<br/> - 超过1000个关卡！<br/> ' ,   
            ],
        appleURL:'#',
        googleURL:'#',
        downloads:'50000+',
        imgURL:'../../static/img/games/fmj16_icon.png'
    },
    fbt:{
        gameKey:'fbt',
        name:['复古蜘蛛纸牌','复古蜘蛛纸牌','Ancient Spider Solitaire',],
        subTitle:['经典的纸牌游戏','经典的纸牌游戏','经典的纸牌游戏',],
        info:[
            '蜘蛛纸牌是当下流行的接龙纸牌玩法的一种。 对于所有卡牌游戏的真实爱好者，蜘蛛纸牌是不可错过的。如果你喜欢经典的纸牌游戏或接龙游戏，如纸牌接龙、空档接龙、金字塔纸牌等，那么蜘蛛纸牌就是为你准备的。<br/> <br/> 蜘蛛纸牌上手很简单，是一种常见的数字解谜玩法，玩起来会让人心情很放松。 这款蜘蛛纸牌从几万种随机牌局中，特别筛选出了有趣的难易适中的牌局，玩家每一轮游戏都会有趣友好的体验。 特别设计的每日挑战功能 <br/>，会激发起玩家更多的兴趣，赢得挑战可以获得大量奖励。 <br/> 你一定会喜欢这款游戏：<br/> 1.看的非常清楚的牌面：够大、够清晰；<br/> 2.赢得每日挑战，获得奖励，锻炼思维；<br/> 3.多种难度的玩法，任你自由选择；<br/> 4.无限次的智能提示和撤销道具；<br/> 5.无需联网、不占空间。<br/> <br/> 如果您从「复古蜘蛛纸牌」中体会到快乐，请分享给您的家人和朋友，这是对我们的莫大帮助。 <br/> ' ,
            '蜘蛛纸牌是当下流行的接龙纸牌玩法的一种。 对于所有卡牌游戏的真实爱好者，蜘蛛纸牌是不可错过的。如果你喜欢经典的纸牌游戏或接龙游戏，如纸牌接龙、空档接龙、金字塔纸牌等，那么蜘蛛纸牌就是为你准备的。<br/> <br/> 蜘蛛纸牌上手很简单，是一种常见的数字解谜玩法，玩起来会让人心情很放松。 这款蜘蛛纸牌从几万种随机牌局中，特别筛选出了有趣的难易适中的牌局，玩家每一轮游戏都会有趣友好的体验。 特别设计的每日挑战功能 <br/>，会激发起玩家更多的兴趣，赢得挑战可以获得大量奖励。 <br/> 你一定会喜欢这款游戏：<br/> 1.看的非常清楚的牌面：够大、够清晰；<br/> 2.赢得每日挑战，获得奖励，锻炼思维；<br/> 3.多种难度的玩法，任你自由选择；<br/> 4.无限次的智能提示和撤销道具；<br/> 5.无需联网、不占空间。<br/> <br/> 如果您从「复古蜘蛛纸牌」中体会到快乐，请分享给您的家人和朋友，这是对我们的莫大帮助。 <br/> ' ,
            '蜘蛛纸牌是当下流行的接龙纸牌玩法的一种。 对于所有卡牌游戏的真实爱好者，蜘蛛纸牌是不可错过的。如果你喜欢经典的纸牌游戏或接龙游戏，如纸牌接龙、空档接龙、金字塔纸牌等，那么蜘蛛纸牌就是为你准备的。<br/> <br/> 蜘蛛纸牌上手很简单，是一种常见的数字解谜玩法，玩起来会让人心情很放松。 这款蜘蛛纸牌从几万种随机牌局中，特别筛选出了有趣的难易适中的牌局，玩家每一轮游戏都会有趣友好的体验。 特别设计的每日挑战功能 <br/>，会激发起玩家更多的兴趣，赢得挑战可以获得大量奖励。 <br/> 你一定会喜欢这款游戏：<br/> 1.看的非常清楚的牌面：够大、够清晰；<br/> 2.赢得每日挑战，获得奖励，锻炼思维；<br/> 3.多种难度的玩法，任你自由选择；<br/> 4.无限次的智能提示和撤销道具；<br/> 5.无需联网、不占空间。<br/> <br/> 如果您从「复古蜘蛛纸牌」中体会到快乐，请分享给您的家人和朋友，这是对我们的莫大帮助。 <br/> ' ,
            ],
        appleURL:'#',
        googleURL:'#',
        downloads:'50000+',
        imgURL:'../../static/img/games/fbt_icon.png'
    },
    fsh:{
        gameKey:'fsh',
        name:['天天乐拼图','天天乐拼图','Daily Happy Jigsaw Puzzle',],
        subTitle:['烧脑的趣味拼图游戏','烧脑的趣味拼图游戏','烧脑的趣味拼图游戏',],
        info:[
            '《天天乐拼图》是一款考验你观察力和想象力的趣味休闲游戏！绝对是你无聊必备的拼图游戏！<br/> <br/> 游戏的规则就是简单的【拆分】+【组合】！<br/> -与常规的拼图游戏不同，烧脑的同时考验你平时对生活细节的观察！<br/> -你可以使用已有的元素并发挥你的想象力对它们进行旋转、组合从而创造出新的物体！<br/> -近一百个益智闯关关卡，趣味十足，发挥想象力，放松心情，释放压力！<br/> <br/> 特点：<br/> 1、轻松上手 <br/> 只需要扭一扭、转一转、拼一拼，适合碎片化时间游玩，十分解压 <br/> 2、激发想象<br/> 从已知到未知，绝妙的组合，略微烧脑的题目，活跃你的思维 <br/> 3、提示功能 <br/> 遇到难题不用怕，巧用提示轻松闯关 <br/> 4、老少皆宜 <br/> 适合各年龄段的益智游戏爱好者游玩，儿童大人都能找到乐趣！ <br/> 5、可爱画风 <br/> 手绘风格的图形，可爱小清新风格的界面 <br/> 6、 离线体验<br/> 无需联网，随时随地训练你的大脑<br/> <br/> 超多充满挑战性的关卡，训练你的眼力和脑力，快来解决所有问题成为天天乐拼图大师吧！<br/> ',
            '《天天乐拼图》是一款考验你观察力和想象力的趣味休闲游戏！绝对是你无聊必备的拼图游戏！<br/> <br/> 游戏的规则就是简单的【拆分】+【组合】！<br/> -与常规的拼图游戏不同，烧脑的同时考验你平时对生活细节的观察！<br/> -你可以使用已有的元素并发挥你的想象力对它们进行旋转、组合从而创造出新的物体！<br/> -近一百个益智闯关关卡，趣味十足，发挥想象力，放松心情，释放压力！<br/> <br/> 特点：<br/> 1、轻松上手 <br/> 只需要扭一扭、转一转、拼一拼，适合碎片化时间游玩，十分解压 <br/> 2、激发想象<br/> 从已知到未知，绝妙的组合，略微烧脑的题目，活跃你的思维 <br/> 3、提示功能 <br/> 遇到难题不用怕，巧用提示轻松闯关 <br/> 4、老少皆宜 <br/> 适合各年龄段的益智游戏爱好者游玩，儿童大人都能找到乐趣！ <br/> 5、可爱画风 <br/> 手绘风格的图形，可爱小清新风格的界面 <br/> 6、 离线体验<br/> 无需联网，随时随地训练你的大脑<br/> <br/> 超多充满挑战性的关卡，训练你的眼力和脑力，快来解决所有问题成为天天乐拼图大师吧！<br/> ',
            '《天天乐拼图》是一款考验你观察力和想象力的趣味休闲游戏！绝对是你无聊必备的拼图游戏！<br/> <br/> 游戏的规则就是简单的【拆分】+【组合】！<br/> -与常规的拼图游戏不同，烧脑的同时考验你平时对生活细节的观察！<br/> -你可以使用已有的元素并发挥你的想象力对它们进行旋转、组合从而创造出新的物体！<br/> -近一百个益智闯关关卡，趣味十足，发挥想象力，放松心情，释放压力！<br/> <br/> 特点：<br/> 1、轻松上手 <br/> 只需要扭一扭、转一转、拼一拼，适合碎片化时间游玩，十分解压 <br/> 2、激发想象<br/> 从已知到未知，绝妙的组合，略微烧脑的题目，活跃你的思维 <br/> 3、提示功能 <br/> 遇到难题不用怕，巧用提示轻松闯关 <br/> 4、老少皆宜 <br/> 适合各年龄段的益智游戏爱好者游玩，儿童大人都能找到乐趣！ <br/> 5、可爱画风 <br/> 手绘风格的图形，可爱小清新风格的界面 <br/> 6、 离线体验<br/> 无需联网，随时随地训练你的大脑<br/> <br/> 超多充满挑战性的关卡，训练你的眼力和脑力，快来解决所有问题成为天天乐拼图大师吧！<br/> ',
            ],
        appleURL:'#',
        googleURL:'#',
        downloads:'500k+',
        imgURL:'../../static/img/games/fsh_icon.png'
    },
    fbts:{
        gameKey:'fbts',
        name:['一起来涂色','一起来涂色','Together Paint',],
        subTitle:['专为爱好美术和涂鸦的人们设计','专为爱好美术和涂鸦的人们设计','专为爱好美术和涂鸦的人们设计',],
        info:[
            '欢迎来到“一起来涂色”，一个为爱好美术和涂鸦的人们设计的画画涂色书。<br/> 我们的画画涂色书玩法非常简单，你只需要选择一个图像，然后根据相应的数字填充颜色。<br/> 玩家可以选择的图片种类非常广泛，包括二次元、古风、动漫、头像、美食和动物等。<br/> 我们设计了精美的画面，让玩家可以极简的方式表达自己的涂鸦风格。<br/> 无论是想将一副多彩图像或是想要放松身心，绘画涂色书都能满足你的需求。现在就下载“一起来涂色”，并开始创造你美妙的涂鸦世界吧！',   
            '欢迎来到“一起来涂色”，一个为爱好美术和涂鸦的人们设计的画画涂色书。<br/> 我们的画画涂色书玩法非常简单，你只需要选择一个图像，然后根据相应的数字填充颜色。<br/> 玩家可以选择的图片种类非常广泛，包括二次元、古风、动漫、头像、美食和动物等。<br/> 我们设计了精美的画面，让玩家可以极简的方式表达自己的涂鸦风格。<br/> 无论是想将一副多彩图像或是想要放松身心，绘画涂色书都能满足你的需求。现在就下载“一起来涂色”，并开始创造你美妙的涂鸦世界吧！',   
            '欢迎来到“一起来涂色”，一个为爱好美术和涂鸦的人们设计的画画涂色书。<br/> 我们的画画涂色书玩法非常简单，你只需要选择一个图像，然后根据相应的数字填充颜色。<br/> 玩家可以选择的图片种类非常广泛，包括二次元、古风、动漫、头像、美食和动物等。<br/> 我们设计了精美的画面，让玩家可以极简的方式表达自己的涂鸦风格。<br/> 无论是想将一副多彩图像或是想要放松身心，绘画涂色书都能满足你的需求。现在就下载“一起来涂色”，并开始创造你美妙的涂鸦世界吧！',   
            ],
        appleURL:'#',
        googleURL:'#',
        downloads:'1M+',
        imgURL:'../../static/img/games/fbts_icon.png'
    },
    bjm:{
        gameKey:'bjm',
        name:['泡泡消消乐','泡泡消消乐','Bubble Pop',],
        subTitle:['令人上瘾的放松泡泡合并益智游戏','令人上瘾的放松泡泡合并益智游戏','令人上瘾的放松泡泡合并益智游戏',],
        info:[
            '“泡泡消消乐”是一个令人上瘾的放松泡泡合并益智游戏。连接相同编号的气泡以合并它们！创建绝佳的链接并将它们合并以获得更多积分！挑战你的头脑并解决难题，然后你会发现它们简单而令人兴奋！<br/> <br/> 怎么玩？<br/> ⁃ 在任意八个方向（上,下,左,右或对角线）上滑动相同的数字以合并它们。<br/> ⁃ 相同数字的气泡将合并为更大数字的气泡。<br/> ⁃ 没有时间限制！<br/> ⁃ 只是滑动！<br/> <br/> 特征：<br/> ⁃ 精美易用，简单明了，没有压力，没有时间限制。<br/> ⁃ 挑战并打破你的极限分数。<br/> ⁃ 玩法简单。经典的合并数字游戏，适合所有年龄段！<br/> ⁃ 美丽多样的背景图片。<br/> ⁃ 多种材质的气泡。如：铁、水晶、木头等<br/> <br/> 快来玩这个游戏，成为泡泡消消乐游戏的大师吧！ ' ,   
            '“泡泡消消乐”是一个令人上瘾的放松泡泡合并益智游戏。连接相同编号的气泡以合并它们！创建绝佳的链接并将它们合并以获得更多积分！挑战你的头脑并解决难题，然后你会发现它们简单而令人兴奋！<br/> <br/> 怎么玩？<br/> ⁃ 在任意八个方向（上,下,左,右或对角线）上滑动相同的数字以合并它们。<br/> ⁃ 相同数字的气泡将合并为更大数字的气泡。<br/> ⁃ 没有时间限制！<br/> ⁃ 只是滑动！<br/> <br/> 特征：<br/> ⁃ 精美易用，简单明了，没有压力，没有时间限制。<br/> ⁃ 挑战并打破你的极限分数。<br/> ⁃ 玩法简单。经典的合并数字游戏，适合所有年龄段！<br/> ⁃ 美丽多样的背景图片。<br/> ⁃ 多种材质的气泡。如：铁、水晶、木头等<br/> <br/> 快来玩这个游戏，成为泡泡消消乐游戏的大师吧！ ' ,   
            '“泡泡消消乐”是一个令人上瘾的放松泡泡合并益智游戏。连接相同编号的气泡以合并它们！创建绝佳的链接并将它们合并以获得更多积分！挑战你的头脑并解决难题，然后你会发现它们简单而令人兴奋！<br/> <br/> 怎么玩？<br/> ⁃ 在任意八个方向（上,下,左,右或对角线）上滑动相同的数字以合并它们。<br/> ⁃ 相同数字的气泡将合并为更大数字的气泡。<br/> ⁃ 没有时间限制！<br/> ⁃ 只是滑动！<br/> <br/> 特征：<br/> ⁃ 精美易用，简单明了，没有压力，没有时间限制。<br/> ⁃ 挑战并打破你的极限分数。<br/> ⁃ 玩法简单。经典的合并数字游戏，适合所有年龄段！<br/> ⁃ 美丽多样的背景图片。<br/> ⁃ 多种材质的气泡。如：铁、水晶、木头等<br/> <br/> 快来玩这个游戏，成为泡泡消消乐游戏的大师吧！ ' ,   
            ],
        appleURL:'#',
        googleURL:'#',
        downloads:'500k+',
        imgURL:'../../static/img/games/bjm_icon.png'
    },
}


export {
    index,
    games
}



// WEBPACK FOOTER //
// ./src/assets/game_data.js